import { useState, useEffect } from "react";
import logo from "./image/PranaSrishti.svg";

function Header() {
  const [menuActive, setMenuActive] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Sticky header effect
  useEffect(() => {
    const header = document.getElementById("myHeader");
    if (!header) return;

    const sticky = header.offsetTop;

    const handleScroll = () => {
      if (window.pageYOffset > sticky) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header>
      {/* Top header */}
      <div className="new-top-header-area">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-sm-8">
              <ul className="header-content-left">
                <li>
                  <a href="mailto:sales@pranasrishti.com">
                    <i className="bx bx-envelope"></i>Email: sales@pranasrishti.com
                  </a>
                </li>
                <li>
                  <i className="bx bx-location-plus"></i> Delhi, 110053
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-sm-4">
              <ul className="header-content-right">
                <li>
                  <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                    <i className="bx bxl-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer">
                    <i className="bx bxl-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                    <i className="bx bxl-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                    <i className="bx bxl-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Main header */}
      <div
        className={`main-header-ps header ${isSticky ? "sticky" : ""}`}
        id="myHeader"
      >
        <a href="/" className="logo">
          <img src={logo} alt="PranaSrishti" width="239" height="40" />
        </a>

        <div className="menu-toggle" id="menu-toggle" onClick={handleMenuToggle}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav id="navbar" className={menuActive ? "active" : ""}>
          <ul>
            <li>
              <a href="/about">About Us</a>
            </li>
            <li>
              <a href="#">Services ▾</a>
              <div className="mega-menu">
                <div className="row">
                  <div>
                    <a href="/Web-WASA"><i class="bx bx-globe"></i> Web / WASA</a>
                    <a href="/Mobile-Android-IOS"><i class="bx  bx-mobile"></i> Mobile - (Android/ios)</a>
                    <a href="/Networking-Infrastructure"><i class="bx bx-signal-5"></i> Networking/Infrastructure </a>
                    <a href="/Source-code-review"><i class="bx bx-server"></i> SCR</a>
                    <a href="/Configuration-Review"><i class="bx bx-cog"></i> Configurations Review </a>
                    <a href="/IOT"><i class="bx bx-fingerprint"></i> IOT</a>
                    <a href="/OT"><i class="bx bx-shield-alt-2"></i> OT</a>
                    <a href="/Red-Team-Assessment"><i class="bx bx-unlink"></i> Red Teaming</a>
                    <a href="/Software-Composition-Analysis"><i class="bx bx-windows"></i> SCA</a>
                    <a href="/API-Security-Testing"><i class="bx bx-door-open"></i> API</a>
                    
                  </div>
                  <div>
                    <a href="/Medical-Device-Security"><i class="bx bx-plus-circle"></i> Medical Device Security Testing</a>
                    <a href="/ISO"><i class="bx bx-git-compare"></i> ISO</a>
                    <a href="/SOC"><i class="bx bx-shield-alt"></i> SOC</a>
                    <a href="/GDPR"><i class="bx bx-chart"></i> GDPR</a>
                    <a href="/Hippa"><i class="bx bx-donate-blood"></i> Hippa</a>
                    <a href="/SAR-DL"><i class="bx bx-news"></i> SAR DL</a>
                    <a href="/ASP-esign"><i class="bx bx-doughnut-chart"></i> ASP esign</a>
                    <a href="/IS-Audit"><i class="bx bx-credit-card-front"></i> IS Audit</a>
                    <a href="/DPDP"><i class="bx bx-file"></i> DPDP</a>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a href="/Contact-us">Contact</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
          </ul>
        </nav>

        <div className="others-option d-flex align-items-center">
          <div className="option-item">
            <a className="default-btn" href="/Contact-us">
              Get A Free Quote
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
